// import { useEffect, useState } from "react";

// const useFetch = (url, token) => {
//   const [data, setData] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);

//       try {
//         const headers = token ? { Authorization: `Bearer ${token}` } : {};
//         const res = await fetch(url, { headers });
//         if (!res.ok) {
//           throw new Error(`HTTP error! status: ${res.status}`);
//         }
//         const json = await res.json();

//         setData(json);
//         setLoading(false);
//       } catch (error) {
//         setError(error);
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [url, token]);

//   return { loading, error, data };
// };

// export default useFetch;

import { useState, useEffect } from 'react';

import getAuthHeader from './auth-header';

const useFetch = (url) => {

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchData = async () => {

      setLoading(true);

      try {
        
        const headers = getAuthHeader();
        
        const res = await fetch(url, { headers });

        if(!res.ok) {
          throw new Error(res.statusText);
        }
       
        const json = await res.json();

        setData(json);
        setLoading(false);

      } catch (error) {

        setError(error.message);
        setLoading(false);  

      }

    };

    fetchData();

  }, [url]);

  return { loading, error, data };

};

export default useFetch;


